// constants.js
import img from "../images/projects/project-1.jpeg";
import img2 from "../images/projects/project-2.jpeg";
import img3 from "../images/projects/project-3.jpeg";
import img4 from "../images/projects/project-4.jpeg";

export const APP_NAME = "S G C";
export const APP_LOGO = "../../images/projects/project-4.jpeg";
export const APP_DESCRIPTION =
  "Wisdom Tec provides best software solutions for your unique business needs";
export const BACKGROUND_COLOR = "#0B192C";
export const TEXT_COLOR = "#FFFFFF";
export const SECONDARY_COLOR = "#FF6500";
export const NAV_ITEMS = ["About", "Services", "Contact Us"];



export const projects = [
  {
    img: img,
    title: "Carrefour Building",
    location: "Jabel Ali Industrial Area 1 Dubai",
    description:
      "It offers spacious residential rooms with essential furniture and proper ventilation. The building is equipped with multiple washrooms and showers maintained to high cleanliness standards, ensuring the well-being of its residents. The project prioritizes safety by 24/7 security, including CCTV surveillance and trained personnel. Reliable electricity and water supply, backed by contingency systems, guarantee uninterrupted services. Carrefour Building is an ideal facility for effective labour management.",
  },
  {
    img: img2,
    title: "Bin Dasmal Printing Press",
    location: "Sonapur Mohaisnah 1 Dubai",
    description:
      "It offers spacious residential rooms with essential furniture and proper ventilation. The building is equipped with multiple washrooms and showers maintained to high cleanliness standards, ensuring the well-being of its residents. The project prioritizes safety by 24/7 security, including CCTV surveillance and trained personnel. Reliable electricity and water supply, backed by contingency systems, guarantee uninterrupted services. Bin Dasmal Printing Press is an ideal facility for effective labour management.",
  },
  {
    img: img3,
    title: "Labour Rights Social Media Marketing",
    location: "Sonapur Mohaisnah 1 Dubai",
    description:
      "It offers spacious residential rooms with essential furniture and proper ventilation. The building is equipped with multiple washrooms and showers maintained to high cleanliness standards, ensuring the well-being of its residents. The project prioritizes safety by 24/7 security, including CCTV surveillance and trained personnel. Reliable electricity and water supply, backed by contingency systems, guarantee uninterrupted services. Labour Rights Social Media Marketing is an ideal facility for effective labour management.",
  },
  {
    img: img4,
    title: "Rashid Buset Building",
    location: "Sonapur Mohaisnah 1 Dubai",
    description:
      "It offers spacious residential rooms with essential furniture and proper ventilation. The building is equipped with multiple washrooms and showers maintained to high cleanliness standards, ensuring the well-being of its residents. The project prioritizes safety by 24/7 security, including CCTV surveillance and trained personnel. Reliable electricity and water supply, backed by contingency systems, guarantee uninterrupted services. Rashid Buset Building is an ideal facility for effective labour management.",
  },
];
